import React from "react";
import { Button } from "../../../../../ui";
import "./ui-pending.scss";

interface PagerProps {
  /** e.g. "Page 2 of 5" */
  summary: React.ReactNode;
  canPrev: boolean;
  canNext: boolean;
  onPrev: () => void;
  onNext: () => void;
  className?: string;
}

/** Previous / Next pager for server-paged lists (design-system candidate). */
export const Pager: React.FC<PagerProps> = ({ summary, canPrev, canNext, onPrev, onNext, className }) => (
  <nav className={["tesc-pager", className].filter(Boolean).join(" ")} aria-label="Pagination">
    <span className="tesc-pager__summary">{summary}</span>
    <div className="tesc-pager__buttons">
      <Button size="sm" variant="secondary" disabled={!canPrev} onClick={onPrev}>
        Previous
      </Button>
      <Button size="sm" variant="secondary" disabled={!canNext} onClick={onNext}>
        Next
      </Button>
    </div>
  </nav>
);

export default Pager;
